module.exports = __webpack_public_path__ + "img/Airbnb-Productivity-Focused-Breathing-Grounding-Breath.217647c6.jpg";